var map = {
	"./schweizer5-eventlocation-frankfurt-1.jpg": 13,
	"./schweizer5-eventlocation-frankfurt-2.jpg": 14,
	"./schweizer5-eventlocation-frankfurt-3.jpg": 15,
	"./schweizer5-eventlocation-frankfurt-4.jpg": 16,
	"./schweizer5-eventlocation-frankfurt-5.jpg": 17,
	"./schweizer5-eventlocation-frankfurt-6.jpg": 18,
	"./schweizer5-eventlocation-frankfurt-7.jpg": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12;